import { number } from "yup";
import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const BlacklistWordsConfigService = {
  getAll: (account_id: number) => {
    return HTTP.get<any, any>(
      `${API_ENDPOINT.CORE}accounts/blacklist/${account_id}`
    );
  },

  addWord: (accountId: number, word: string) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/blacklist`, {
      accountId,
      word,
    });
  },

  editWord: (word_id: number, word: string) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/blacklist`, {
      word_id,
      word,
    });
  },

  deleteWord: (word_id: number) => {
    return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}accounts/blacklist`, {
      data: { word_id },
    });
  },

  getReport: (account_id: number) => {
    return HTTP.get<any, any>(
      `${API_ENDPOINT.CORE}accounts/blacklist/report/${account_id}`
    );
  },

};
